export { default } from './ExpandArrowsIcon';
